import { render } from "./Ongoing_Course_Summary.vue?vue&type=template&id=cd87b9e8&ts=true"
import script from "./Ongoing_Course_Summary.vue?vue&type=script&lang=ts"
export * from "./Ongoing_Course_Summary.vue?vue&type=script&lang=ts"

import "./Ongoing_Course_Summary.vue?vue&type=style&index=0&id=cd87b9e8&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__